import { PRICING } from "../data/site";
import { Reveal } from "./Reveal";

export const Pricing = () => (
  <>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-testid="pricing-grid">
      {PRICING.map((p, i) => (
        <Reveal key={p.title} delay={i * 0.08}>
          <div
            data-testid={`pricing-card-${i}`}
            className="h-full rounded-2xl border-t-2 border-[#8A9B87] bg-white p-7 shadow-[0_8px_30px_rgb(0,0,0,0.03)] transition-[transform,box-shadow] duration-300 hover:scale-[1.02] hover:shadow-[0_20px_40px_rgb(0,0,0,0.08)]"
          >
            <p className="text-sm uppercase tracking-[0.14em] text-[#8A9B87]">{p.title}</p>
            <p className="mt-4 text-3xl font-light text-[#2E2E2C]">{p.price}</p>
            <p className="mt-2 text-sm text-[#2E2E2C]/60">{p.detail}</p>
          </div>
        </Reveal>
      ))}
    </div>

    <Reveal delay={0.1}>
      <div
        data-testid="pricing-sauna"
        className="mt-5 flex flex-wrap items-baseline justify-between gap-3 rounded-2xl bg-[#A9805B]/10 px-7 py-6"
      >
        <p className="text-sm uppercase tracking-[0.14em] text-[#A9805B]">Sauna</p>
        <p className="text-2xl font-light text-[#2E2E2C]">+50 €</p>
      </div>
    </Reveal>

    <Reveal delay={0.16}>
      <p className="mt-8 max-w-2xl text-sm text-[#2E2E2C]/60 leading-relaxed">
        Tila on vuokrattavissa arki-iltaisin sekä viikonloppuisin (pe–su). Vakiotuntivuorot ovat sovittavissa erikseen.
      </p>
    </Reveal>
  </>
);
